import React from 'react';
import PropTypes from 'prop-types';
import { Blockquote, BrushElement } from './styles';
import quotation from '../../assets/brush/brush-quotation.png';

/**
 * Renders a blockquote with speech graphic
 */
const Quotation = ({ children }) => (
  <Blockquote>
    <BrushElement src={quotation} alt="" />
    {children}
  </Blockquote>
);

Quotation.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
};

export default Quotation;
